module.exports = __webpack_public_path__ + "img/CV.Drainage_SUDS.Attenuation.Dry_Swale.8df88712.png";